/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelDistanceAlert.ts                 *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "dispatch/distance_alert";

export class AutogenModelDistanceAlert<RowType extends ModelRow> extends Endpoint<RowType, RowDistanceAlertFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowDistanceAlert extends ModelRow<RowDistanceAlertFields> {
	constructor(values?: Partial<RowDistanceAlertFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowDistanceAlertFields {
	city_id: number;
	comments: string;
	company_id: string;
	create_date: Date;
	dest_address: string;
	dest_city_name: string;
	dest_state: string;
	dest_zip_code: string;
	distance_profile: string;
	id: string;
	is_cleared: string;
	method_id: string;
	movement_id: string;
	movement_sequence: number;
	order_id: string;
	order_sequence: number;
	origin_address: string;
	origin_city_name: string;
	origin_state: string;
	origin_zip_code: string;
	source_id: string;
	type_id: string;
}

